var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.937014 10.6082C0.582717 10.2735 0 10.5247 0 11.0121V33.3332C0 34.5605 0.994924 35.5554 2.22222 35.5554H37.7778C39.0051 35.5554 40 34.5605 40 33.3332V11.0121C40 10.5247 39.4173 10.2736 39.063 10.6082L21.5258 27.171C20.6694 27.9799 19.3306 27.9799 18.4742 27.171L0.937014 10.6082ZM38.4742 5.05098C38.6419 4.89261 38.6348 4.60258 38.4138 4.53668C38.2123 4.4766 37.9988 4.44434 37.7778 4.44434H2.22222C2.00121 4.44434 1.78774 4.4766 1.58625 4.53667C1.36521 4.60258 1.35815 4.89261 1.52584 5.05098L19.6185 22.1385C19.8327 22.3408 20.1674 22.3408 20.3815 22.1385L38.4742 5.05098Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.a9de2a0437aa56d5e346d1a95355bbf7.svg";
export { ForwardRef as ReactComponent };